import { useMemo } from 'react'
import { create } from 'zustand'
import { getXPlatformTokenDecoded, isUserLoggedInFn, type XPlatformInfo } from '../utils/getXPlatformToken'

export const useXPlatformStore = create<{
  xPlatformInfo: XPlatformInfo | null
  setXPlatformInfo: (xPlatformInfo: XPlatformInfo | null) => void
}>()(set => ({
  xPlatformInfo: getXPlatformTokenDecoded(),
  setXPlatformInfo: (xPlatformInfo: XPlatformInfo | null) => set({ xPlatformInfo }),
}))

export const useXPlatformInfo = () => {
  const { xPlatformInfo, setXPlatformInfo } = useXPlatformStore()
  const isUserLoggedIn = useMemo(() => isUserLoggedInFn(xPlatformInfo), [xPlatformInfo])
  /**
   * 當 xPlatformInfo 為 null 時，表示還在載入 xPlatformInfo，這時候需要 loading 狀態避免判斷錯誤
   */
  const isXPlatformInfoLoading = xPlatformInfo === null
  return {
    setXPlatformInfo,
    xPlatformInfo,
    isXPlatformInfoLoading,
    isUserLoggedIn,
  }
}
